import { ApplicationType } from "@redotech/media-type/application";

/**
 * application/json
 * @see {@link https://datatracker.ietf.org/doc/html/rfc8259#section-1.2 RFC 8259 §1.2 Specifications of JSON}
 */
export const ApplicationJsonType = ApplicationType.subtype("json");

export const ApplicationFormUrlEncodedType = ApplicationType.subtype(
  "x-www-form-urlencoded",
);
